var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInviteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    rx: 24,
    fill: "url(#paint0_linear_41_3030)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_41_3030)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5355 31.4645C56.5827 29.5118 53.417 29.5118 51.4645 31.4645L47.7144 35.2145C46.7381 36.1908 45.1552 36.1908 44.1789 35.2145C43.2026 34.2381 43.2026 32.6552 44.1789 31.6789L47.9289 27.9289C51.8343 24.0237 58.1657 24.0237 62.071 27.9289C65.9762 31.8342 65.9762 38.1658 62.071 42.0711L54.571 49.5711C50.6657 53.4762 44.3342 53.4762 40.4289 49.5711C39.4526 48.5948 39.4526 47.0119 40.4289 46.0355C41.4052 45.0592 42.9881 45.0592 43.9644 46.0355C45.917 47.9882 49.0828 47.9882 51.0355 46.0355L58.5355 38.5355C60.488 36.5829 60.488 33.4171 58.5355 31.4645ZM46.0355 43.9645C44.0829 42.0118 40.9171 42.0118 38.9645 43.9645L31.4645 51.4645C29.5118 53.417 29.5118 56.583 31.4645 58.5355C33.4171 60.4883 36.5829 60.4883 38.5355 58.5355L42.2855 54.7855C43.2619 53.8092 44.8448 53.8092 45.8211 54.7855C46.7974 55.7617 46.7974 57.3447 45.8211 58.321L42.0711 62.071C38.1658 65.9762 31.8342 65.9762 27.9289 62.071C24.0237 58.1657 24.0237 51.8342 27.9289 47.9289L35.4289 40.4289C39.3342 36.5237 45.6658 36.5237 49.5711 40.4289C50.5475 41.4052 50.5475 42.9881 49.5711 43.9645C48.5948 44.9408 47.0119 44.9408 46.0355 43.9645Z",
    fill: "url(#paint1_linear_41_3030)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_41_3030",
    x: 12,
    y: 22,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_41_3030"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_41_3030",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_41_3030",
    x1: 45,
    y1: 0,
    x2: 45,
    y2: 90,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A711E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB829"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_41_3030",
    x1: 45,
    y1: 25,
    x2: 45,
    y2: 64.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE660"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteIcon);
export default __webpack_public_path__ + "static/media/invite_icon.f380af0a05fba8a71a83151acb2e807a.svg";
export { ForwardRef as ReactComponent };